import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../_common/components/Footer/Footer";

type RootState = {
  notifications: {
    totalCount: number;
  };
};

export const NotificationsFooter = () => {
  const { count } = useSelector(
    (state: RootState) => ({ count: state.notifications.totalCount }),
    shallowEqual
  );

  return <Footer count={count} />;
};
